'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _reduxActions = require('redux-actions');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _strings = require('conversations-core/constants/strings');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = null;

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes2.default.SET_CURRENT_CHANNEL, function (currentChannel, action) {
  return action.payload.channel;
}), _defineProperty(_handleActions, _ActionTypes2.default.ADD_MESSAGE_TO_CONVERSATION, function (currentChannel, action) {
  if (currentChannel) return currentChannel;
  return action.payload.channel;
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_WIDGET_DATA_SUCCEEDED, function (currentChannel, action) {
  if (action.payload.online) return _strings.INITIAL_ONLINE_MODE_CHANNEL;
  return _strings.OFFLINE_MODE_CHANNEL;
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/reducers/currentChannel.js
// module id = 508
// module chunks = 0